import { NodeClient } from './nodeClient';
/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param apiKey API Key for project.
 * @param options Options to pass to the client.
 */
export function init(apiKey, options) {
    if (options === void 0) { options = {}; }
    var nodeClient = new NodeClient(apiKey, options);
    return nodeClient;
}
//# sourceMappingURL=sdk.js.map